import React, { useState } from "react";
import Modal from "../modal";
import Button from "../button";

const CustomFilePicker = ({
	onFileSelected,
	acceptedFileTypes = [".txt", ".pdf", "csv", "xlsx"],
	name = "file",
	value,
	disabled = false,
}) => {
	const [selectedFile, setSelectedFile] = useState(null);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file && isFileTypeValid(file)) {
			setSelectedFile(file);
			onFileSelected(file);
		} else {
			// Handle invalid file type
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Error",
				message: `Invalid file type. Please select a valid file (accepted types: ${acceptedFileTypes.join(
					", "
				)}).`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setSelectedFile(null);
			e.target.value = null;
		}
	};

	const isFileTypeValid = (file) => {
		const acceptedTypes = acceptedFileTypes.map((type) => type.toLowerCase());
		return (
			acceptedTypes.includes(file.type.toLowerCase()) ||
			acceptedTypes.includes(file.name.split(".").pop().toLowerCase())
		);
	};

	const buttonStyle = {
		color: "#fff",
		padding: "10px 15px",
		borderRadius: "5px",
		cursor: "pointer",
	};
	const inputRef = React.useRef(null);
	return (
		<div>
			<button
				className={`bg-primary-primaryYellow text-black px-2 py-2 mt-4 rounded-md font-bold ${
					disabled ? "bg-secondary-buttonGray text-secondary-lightestGray" : ""
				} `}
				onClick={() => inputRef.current.click()}
				disabled={disabled}
			>
				{value}
			</button>
			<input
				type="file"
				accept={acceptedFileTypes.join(",")}
				ref={inputRef}
				className="hidden"
				name={name}
				onChange={handleFileChange}
			/>
			<label className="file-label text-black ml-2" htmlFor="file-input">
				{selectedFile ? selectedFile.name : "Choose File"}
			</label>
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</div>
	);
};

// Example usage:
// <CustomFilePicker
//   onFileSelected={(file) => console.log('Selected File:', file)}
//   acceptedFileTypes={['.txt', '.pdf']}
//   buttonColor="#3498db"
// />

export default CustomFilePicker;
